import React from 'react';
import { motion } from 'framer-motion';
import LogoRing from './LogoRing';

const PartnersSection = () => {
    const partners = [
        { name: 'Amazon', logo: '/companylogo/Amazon-logo.png' },
        { name: 'HCL', logo: '/companylogo/HCL-logo.png' },
        { name: 'IBM', logo: '/companylogo/IBM-logo.png' },
        { name: 'PwC', logo: '/companylogo/Pwc-log.png' },
        { name: 'TCS', logo: '/companylogo/TCS-logo.png' },
        { name: 'Tech Mahindra', logo: '/companylogo/TechMahindra-logo.png' },
    ];

    return (
        <section className="py-20 md:py-24 flex flex-col justify-center bg-white overflow-hidden relative">
            {/* Visual Decoration */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[200px] bg-blue-500/5 rounded-full blur-[100px] -z-1" />

            <div className="container mx-auto px-4 md:px-6 mb-12 md:mb-16 text-center relative z-10">
                <motion.span
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="text-primary font-black uppercase tracking-[0.4em] text-[10px] md:text-xs mb-4 block"
                >
                    Trusted by Industry Leaders
                </motion.span>
                <motion.h2
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.1 }}
                    className="text-2xl md:text-4xl lg:text-5xl font-black text-slate-900 tracking-tight"
                >
                    Our Strategic <span className="text-gradient">Partners</span>
                </motion.h2>
            </div>

            <div className="relative z-10 mt-4 md:mt-8">
                <LogoRing partners={partners} />
            </div>
        </section>
    );
};

export default PartnersSection;
